<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-box"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="openAdd"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="position"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
        <v-dialog
            v-model="dialogAdd"
            v-if="dialogAdd"
            max-width="500px"
            persistent
        >
          <v-card class="pa-4">
            <v-card-title>
              <span class="text-h5 mx-3">Thêm position</span>
            </v-card-title>
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col class="my-4" cols="11">
                  <v-text-field
                      v-model="name"
                      filled
                      label="Vị trí"
                      name="position"
                      placeholder="Nhập vị trí"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" justify="center">
                <v-btn class="mr-5" @click="dialogAdd = false"> HỦY</v-btn>
                <v-btn color="primary" @click="add_position"> THÊM MỚI</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogEdit"
            v-if="dialogEdit"
            max-width="500px"
            persistent
        >
          <v-card class="pa-4">
            <v-card-title>
              <span class="text-h5 mx-3">Sửa position</span>
            </v-card-title>
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col class="my-4" cols="11">
                  <v-text-field
                      v-model="positionDetail.name"
                      filled
                      label="Vị trí"
                      name="position"
                      placeholder="Nhập vị trí"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" justify="center">
                <v-btn class="mr-5" @click="dialogEdit = false"> HỦY</v-btn>
                <v-btn color="primary" @click="edit_position"> SỬA</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_POSITION,
  GET_DETAIL_POSITION,
  GET_LIST_POSITION,
  SAVE_POSITION,
  UPDATE_POSITION
} from "@/store/modules/position";


export default {
  name: "Position",
  data() {
    return {
      page: "Danh sách Positions",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Positions",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Tên', value: 'name'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      dialogAdd: false,
      dialogEdit: false,
      name: ''

    }
  },
  computed: {
    ...mapGetters({
      position: "position",
      positionDetail: "positionDetail",
    }),
  },
  async created() {
    await this.$store.dispatch(GET_LIST_POSITION);
    await this.$store.dispatch(GET_DETAIL_POSITION);

  },
  methods: {
    openAdd() {
      this.dialogAdd = true
    },
    async add_position() {
      let data = {
        name: this.name
      }
      await this.$store.dispatch(`${SAVE_POSITION}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.name=''
          this.dialogAdd = false
          this.$store.dispatch(GET_LIST_POSITION);

        }
      });
    },
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_POSITION}`, id).then((data) => {
        if (data) {
          this.dialogEdit = true;
        }
      });
    },
    async edit_position() {
      await this.$store.dispatch(`${UPDATE_POSITION}`, this.positionDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$store.dispatch(GET_LIST_POSITION);
          this.dialogEdit = false
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_POSITION}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_POSITION);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>